import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  Panel,
  Row,
  Col,
  Input,
  Button,
  Message,
  InputPicker,
  Modal,
  Icon,
  Table,
  IconButton,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'

export default function ProjectEvaluationRelationWidget({
  onClickSearch,
  onClearSearch,
  onSelect,
  onDelete,
  searchData,
  setCode,
  setName,
  setYear,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [section, setSection] = useState()
  const [isdelete, setIsdelete] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [relationForm, setRelationForm] = useState(props.isProjectRelationForm)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        bordered
        collapsible
        defaultExpanded
        style={{ marginBottom: '1em' }}
        ref={(section) => {
          setSection(section)
        }}
      >
        {!relationForm > 0 && (
          <Row>
            <Col xs={12} sm={12} md={6}>
              <label>{formSchema.searchRows.projectCodeLabel}</label>
              <Input
                onChange={(e) => {
                  setCode(e)
                }}
                size="lg"
                placeholder=""
              />
            </Col>
            <Col xs={12} sm={12} md={6}>
              <label>{formSchema.searchRows.projectNameLabel}</label>
              <Input
                onChange={(e) => {
                  setName(e)
                }}
                size="lg"
                placeholder=""
              />
            </Col>
            <Col xs={12} sm={12} md={6}>
              <label>{formSchema.searchRows.projectYearOption.label}</label>
              <InputPicker
                onChange={(e) => {
                  setYear(e)
                }}
                style={{ height: 36 }}
                data={formSchema.searchRows.projectYearOption.options}
                block
              />
            </Col>
            <Col xs={12} sm={12} md={6}>
              <div style={{ marginTop: '22px' }}>
                <Button
                  color="green"
                  appearance="ghost"
                  style={{ width: '80px' }}
                  onClick={() => onClickSearch()}
                >
                  {formSchema.searchRows.buttonSearchText}
                </Button>
                <Button
                  color="yellow"
                  appearance="ghost"
                  style={{ marginLeft: '10px', width: '80px' }}
                  onClick={() => {
                    onClearSearch()
                  }}
                >
                  {formSchema.searchRows.buttonCancelText}
                </Button>
              </div>
            </Col>
          </Row>
        )}

        {searchData?.length > 0 && (
          <>
            <br />
            <Table height={400} wordWrap bordered data={searchData}>
              <Column width={100} align="center" fixed>
                <HeaderCell>รหัสโครงการ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return searchData[index].projectCode
                  }}
                </Cell>
              </Column>
              <Column width={400} align="left" fixed>
                <HeaderCell>ชื่อโครงการ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return searchData[index].projectName
                  }}
                </Cell>
              </Column>
              <Column minWidth={100} align="right" flexGrow={1}>
                <HeaderCell>งบประมาณโครงการ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return searchData[index].projectBudget
                  }}
                </Cell>
              </Column>
              <Column minWidth={100} align="right" flexGrow={1}>
                <HeaderCell>ปีงบประมาณ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return searchData[index].projectYear ? searchData[index].projectYear : ''
                  }}
                </Cell>
              </Column>

              <Column width={200} align="center">
                <HeaderCell></HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    return (
                      <IconButton
                        icon={<Icon appearance="ghost" icon={formSchema.rowButton.buttonIcon} />}
                        onClick={(e) => {
                          onSelect(index)
                        }}
                        style={{ marginRight: 5 }}
                      >
                        {formSchema.rowButton.buttonText}
                      </IconButton>
                    )
                  }}
                </Cell>
              </Column>
            </Table>
          </>
        )}

        {formSchema.values?.length > 0 && (
          <Row style={{ marginTop: 10 }}>
            <Table height={400} wordWrap bordered data={formSchema.values}>
              <Column width={100} align="center" fixed>
                <HeaderCell>รหัสโครงการ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return formSchema.values[index].projectCode
                  }}
                </Cell>
              </Column>
              <Column width={400} align="left" fixed>
                <HeaderCell>ชื่อโครงการ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return formSchema.values[index].projectName
                  }}
                </Cell>
              </Column>
              <Column minWidth={100} align="right" flexGrow={1}>
                <HeaderCell>งบประมาณโครงการ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return formSchema.values[index].projectBudget
                  }}
                </Cell>
              </Column>
              <Column minWidth={100} align="right" flexGrow={1}>
                <HeaderCell>ปีงบประมาณ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return formSchema.values[index].projectYear
                      ? formSchema.values[index].projectYear
                      : ''
                  }}
                </Cell>
              </Column>

              <Column width={200} align="center">
                <HeaderCell></HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    return (
                      <IconButton
                        icon={<Icon appearance="ghost" icon={formSchema.rowButton.buttonIcon} />}
                        onClick={(e) => {
                          setIsdelete(true)
                          setDeleteIndex(index)
                        }}
                        style={{ marginRight: 5 }}
                      >
                        {formSchema.rowButton.buttonText}
                      </IconButton>
                    )
                  }}
                </Cell>
              </Column>
            </Table>
          </Row>
        )}
      </Panel>
      <Modal
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบไฟล์'}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(deleteIndex)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteIndex('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
